import { ActionButton } from './ActionButton'

interface MetricCardProps {
  value: string | number
  label: string
  actionText?: string
  onActionClick?: () => void
  variant?: 'default' | 'full-width'
  disabled?: boolean
}

export function MetricCard({
  value,
  label,
  actionText,
  onActionClick,
  variant = 'default',
  disabled = false,
}: MetricCardProps) {
  const isFullWidth = variant === 'full-width'

  return (
    <div className="bg-gray-50 rounded-lg p-3 flex flex-col gap-3">
      <div className={`flex ${isFullWidth ? 'flex-col' : 'flex-col'} gap-2`}>
        <div className="text-xs font-light text-gray-900 uppercase tracking-wider">
          {label}
        </div>
        <div className="text-base font-semibold text-gray-900">{value}</div>
      </div>
      {actionText && !isFullWidth && (
        <ActionButton
          onClick={onActionClick}
          disabled={disabled || !onActionClick}
          className="w-fit"
        >
          {actionText}
        </ActionButton>
      )}
    </div>
  )
}
